<template>
  <div>
    <nav-bar-component />
    <div class="container ">
      <div class="row mt-3">
          
          <!-- Inicio da parte da esquerda -->
          
          <div class="col-12 d-md-flex">
            <div class="col-sm-6 col-md-6">
              <div class="form-inline">
              <div class="col-12">
                <div class="buttom-time">
                  <h5 class="text-secondary">Plano escolhido:</h5>
                  &nbsp;&nbsp;
                  <input
                    type="radio"
                    class="btn-check"
                    name="options-outlined"
                    id="buttomMonth"
                    autocomplete="off"
                    v-on:click="buttomMonth"
                  />
                  <label
                    class="btn btn-outline-primary button-time-style"
                    for="buttomMonth"
                    >Mensal</label
                  >&nbsp;
                  <input
                    type="radio"
                    class="btn-check"
                    name="options-outlined"
                    id="buttomYear"
                    autocomplete="off"
                    v-on:click="buttomYear"
                  />
                  <label
                    class="btn btn-outline-primary button-time-style"
                    for="buttomYear"
                    >Anual</label
                  >
                </div>
              </div>
            </div>
  
            <!-- Card de planos -->
  
            <div class="d-md-flex mt-2">
              <div class="d-flex">
                <div class="space col">
                  <input
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    id="essentialPlane"
                    autocomplete="off"
                    v-on:click="essentialPlane"
                  />
                  <label
                    class="btn btn-outline-primary buttom-plans-style"
                    for="essentialPlane"
                  >
                    <p class="mt-2">Plano Light</p>
                    <p class="text-size" v-if="mensalValue">R${{ "887,00/mês" }}</p>
                    <p class="text-size" v-else>R${{ "798,30/mês" }}</p>
                  </label>
                </div>
                <div class="space col">
                  <input
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    id="advancedPlane"
                    autocomplete="off"
                    v-on:click="advancedPlane"
                  />
                  <label
                    class="btn btn-outline-primary buttom-plans-style"
                    for="advancedPlane"
                  >
                    <p class="mt-2">Plano Basic</p>
                    <p class="text-size" v-if="mensalValue">R${{ "1297,00/mês" }}</p>
                    <p class="text-size" v-else>R${{ "1167,30/mês" }}</p>
                  </label>
                </div>
                <div class="space col">
                  <input
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    id="professionalPlane"
                    autocomplete="off"
                    v-on:click="professionalPlane"
                  />
                  <label
                    class="btn btn-outline-primary buttom-plans-style"
                    for="professionalPlane"
                  >
                    <p class="mt-2 ">Plano Pro</p>
                    <p class="text-size" v-if="mensalValue">R${{ "2247,00/mês" }}</p>
                    <p class="text-size" v-else>R${{ "2022,30/mês" }}</p>
                  </label>
                </div>
              </div>
            </div>
  
            <!-- Fim do card de planos -->
  
            <br />
            <div class="">
              <div class="">
                <p class="m-0">Quantas licenças você precisa no total?</p>
                <p class="text-alert-licence text-danger m-0">*Seu plano já inclui 2 licenças</p>
              </div>
              <div class="col-5 col-md-5 col-lg-5 mt-3">
                <input
                  type="number"
                  class="form-control imputLicencas"
                  placeholder="Licenças"
                  v-model="license"
                  v-on:click="onInputFocus"
                  v-on:blur="onInputFocus"
                />
              </div>
  
              <div class="">
                <p class="text-danger mt-2 m-0">
                  Esse será o total de licenças disponíveis para uso.
                </p>
                <p class="text-danger text-max-licence">
                  *O máximo permitido é 150 licenças.
                </p>
              </div>
            </div>
  
            <div class="row text-muted mt-3">
              <div class="col-12 col-md-12 col-lg-12 mt-1">
                <p>
                  Você já possui integração com algum broker de WhatsApp API ?
                </p>
              </div>
              <div class="col-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="sim"
                  name="optradio"
                  value="sim"
                  checked
                />
                Sim
              </div>
              <div class="col-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="nao"
                  name="optradio"
                  value="não"
                  checked
                />
                Não
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-12 col-lg-10 infor-business">
                <p class="fw-bold">
                  O Whatsapp Business API está disponível em todos os planos,
                  mediante contratação junto ao provedor.
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#teste"
                    class="btn-rate"
                  >
                    Entenda mais sobre as tarifações aqui.
                  </button>
                </p>
              </div>
            </div>
          </div>

 <!-- Linha Vertical -->
  
          <div class="col col-md-1 col-lg-1 my-element d-none d-sm-block">
            <div class="box line-vertical d-xs-none"></div>
          </div>

<!-- Inicio da parte da direita -->

          <div class="col-sm-6 col-md-6 ">
            <div class="row">
              <div class="col-12 purchase-summary-head resume-buy-box">
                <p class="text-secondary">Resumo da compra</p>
              </div>
            </div>
                <div class="purchase-summary-body">
                  <div class="row">
                    <div class="col col-md-6 col-sx-6">
                      <span class="fw-bold h6">Recorrência de pagamento</span>
                    </div>
                    <div class="col col-md-3 col-sx-3 h6">
                      <p v-if="mensalValue">Mensal</p>
                      <p v-else>Anual</p>
                    </div>
                  </div>
      
                  <div class="row">
                    <div class="col col-md-6 col-sx-6">
                      <span class="fw-bold h6">Valor por licença</span>
                    </div>
                    <div class="col col-md-6 col-sx-6 h6">
                      <p v-if="mensalValue ">
                        R$ {{ valueMonthPayment[license - 2] }}
                      </p>
                      <p v-else>R$ {{ valueYearPayment[license - 2] }}</p>
                    </div>
                  </div>
      
                  <div class="row">
                    <div class="col col-md-6 col-sx-6 h6">
                      <span class="fw-bold">Quantidade de licenças</span>
                    </div>
                    <div class="col col-md-6 col-sx-6 h6">
                      <p>{{ license }}</p>
                    </div>
                  </div>
      
                  <div class="row">
                    <div class="col col-md-6 col-sx-6 h6">
                      <span class="fw-bold">Subtotal</span>
                    </div>
                    <div class="col col-md-6 col-sx-6 h6">
                      <p v-if="mensalValue">
                        R$ {{ (valueMonthPayment[license - 2] * license).toFixed(2) }}
                      </p>
                      <p v-else>
                        R$ {{ (valueYearPayment[license - 2] * license).toFixed(2) }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 col-sx-6 h6">
                      <span class="fw-bold">Desconto</span>
                    </div>
                    <div class="col col-md-6 col-sx-6 h6">
                      <p v-if="mensalValue">
                        -R$
                        {{
                          (valueMonthPayment[license - 2] * license * 0.11).toFixed(2)
                        }}
                      </p>
                      <p v-else>
                        -R$
                        {{
                          (valueYearPayment[license - 2] * license * 0.11).toFixed(2)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 col-sx-6">
                      <hr class="text-secondary hr-sumary" />
                    </div>
                  </div>
      
                  <div class="row fs-6 fw-bold">
                    <div class="col col col-md-4 col-sx-3 h5">Total mensal</div>
                    <div class="col col-md-3 col-sx-3 h5">
                      <p v-if="mensalValue">
                        R$
                        {{
                          (
                            valueMonthPayment[license - 2] * license -
                            valueMonthPayment[license - 2] * license * 0.11
                          ).toFixed(2)
                        }}
                      </p>
                      <p v-else>
                        R$
                        {{( valueYearPayment[license - 2] * license -
                            valueYearPayment[license - 2] * license * 0.11).toFixed(2)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row text-secondarym">
                    <div class="col infor-next-inv">
                      <p>Esse será o valor a partir da sua próxima fatura.</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
    
      <!-- Botão de finalizar e voltar -->

      <div >
        <div class="col-12 mb-2">
          <div class="d-flex justify-content-center">
            <a
              href="javascript: history.go(-1)"
              class="btn btn-secondary button-back"
              >Voltar</a
            >
            <button
              @click="checkout"
              class="btn btn-primary button-next"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>

      <!-- Modal -->

      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="alert alert-danger" role="alert" v-show="isLicense">
                Informe a quantidade de Licenças
              </div>
              <div class="alert alert-success" v-show="!isLicense" role="alert">
                <p>Você será redirecionado para a tela de pagamento.</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="send()">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    <div class="container">
      <!-- Modal -->
      <div class="modal" id="teste">
        <div class="modal-dialog modal-rate">
          <div class="modal-content modal-rate-size">
            <div class="alert" v-show="!isLicense" role="alert">
              <h3>Custos de tarifação</h3>
              <p>
                <strong>Mensagens Ativas</strong> (quando você inicia uma
                conversa) - R$0,27
              </p>
              <p>
                <strong>Mensagens Passivas</strong> (quando alguém inicia uma
                conversa com você) - R$0,17
              </p>
              <p>
                <strong>Demais mensagens</strong> (as trocas de mensagens que
                você envia dentro da conversa em 24 horas - cada linha (enter)
                que você envia) - R$ 0.005
              </p>
              <br />
              <p>
                <strong
                  >Obs: O Facebook/Meta bonifica as suas primeiras 1.000
                  conversas, logo você só pagará "R$ 0,27" a partir da
                  conversa/mensagem ativa n° 1.001</strong
                >
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>
    
<script>
import axios from "axios";
import Plans from "../plansValue/plansValue";

export default {
  name: "App",
  data() {
    return {
      subscriptions: [],
      params: {},
      license: 2,
      mensalValue: true,
      buttomPlan: true,
      valueMonthPayment: true,
      valueYearPayment: true,
      isLicense: false,
      subscription_code: "",
      termAcceptance: false,
      tymeplan: "mes",
    };
  },
  mounted() {
    this.params = JSON.parse(this.$route.params.data);
    this.getAllSubscriptions();
    this.planSelectend();
    this.tymeplan = localStorage.getItem("timePlan");
    this.setTimePlan();
  },
  watch: {
    license() {
      if (this.license !== "") {
        this.isLicense = false;
      }

      if (this.license > 150) {
        this.license = 150;
      }
      if (this.license < 2) {
        this.license = 2;
      }
    },
  },
  methods: {
    send() {
      if (this.license === "") {
        this.isLicense = true;
        return;
      }
      if (this.license > 2) {
        this.UpdateBilling();
        return;
      }
      this.StartBilling();
    },
    StartBilling() {
      let data = JSON.stringify({
        id_customer: this.params.broker_finance,
        code: this.subscription_code,

        start_additional_subscriptions: false,
        subscription: {
          payment_expiration_day: 5,
        },
        customer: {
          country: "BR",
        },
      });
      let request = this.httpConfig("post", "subscription/start-billing", data);
      axios(request)
        .then((response) => {
          const data = JSON.parse(JSON.stringify(response.data));
          window.location.href = data.invoices[0].checkout_url;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateBilling() {
      let data = JSON.stringify({
        id_customer: this.params.broker_finance,
        code: this.subscription_code,
        sale_item: {
          id: `tallos-${this.params.plano}-${this.license}-2022`,
          name: `${this.params.plano} ${this.license}`,
        },
        billing_config: {
          interval_unit: "month",
          interval_length: 1,
          quantity: 12,
        },
        payment_config: {
          expiration_day: 5,
          payment_mode: "manual",
        },
      });

      let request = this.httpConfig("patch", "subscription", data);
      axios(request)
        .then((response) => {
          if (response.status === 200) {
            this.StartBilling();
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getAllSubscriptions() {
      var config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.VUE_APP_URL_MID_BILLING_API}subscription/${this.params.broker_finance}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then((response) => {
          const subscription = response.data.data[0];
          this.subscription_code = subscription.id;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    httpConfig(method, route, data) {
      var config = {
        method: method,
        maxBodyLength: Infinity,
        url: `${process.env.VUE_APP_URL_MID_BILLING_API}${route} `,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      console.log(config);
      return config;
    },
    planSelectend() {
      if (this.params.plano === "advanced") {
        this.advancedPlane();
        return;
      }

      if (this.params.plano === "essential") {
        this.essentialPlane();
        return;
      }

      if (this.params.plano === "professional") {
        this.professionalPlane();
        return;
      }
    },
    essentialPlane() {
      document.getElementById("essentialPlane").checked = true;
      this.valueMonthPayment = Plans.essential.map((item) => item.valueMonth);
      this.valueYearPayment = Plans.essential.map((item) => item.valueYear);
    },
    professionalPlane() {
      document.getElementById("professionalPlane").checked = true;
      this.valueMonthPayment = Plans.professional.map(
        (item) => item.valueMonth
      );
      this.valueYearPayment = Plans.professional.map((item) => item.valueYear);
    },
    advancedPlane() {
      document.getElementById("advancedPlane").checked = true;
      this.valueMonthPayment = Plans.advanced.map((item) => item.valueMonth);
      this.valueYearPayment = Plans.advanced.map((item) => item.valueYear);
    },
    buttomEssentialPlan() {
      this.buttomPlan = true;
    },
    buttomMonth() {
      this.mensalValue = true;
    },
    buttomYear() {
      this.mensalValue = false;
    },
    setTimePlan() {
      if (this.tymeplan === "mes") {
        document.getElementById("buttomMonth").checked = true;
      } else {
        document.getElementById("buttomYear").checked = true;
        this.mensalValue = false;
      }
    },
  },
};
</script>
    
<style scoped>
.container {
  font-family: "Roboto", sans-serif;
}
.type-plan {
  background-color: #34a9fc;
  border-radius: 10px;
  width: 60px;
  text-align: center;
}
.type-plan-year {
  background-color: #9b8181;
  border-radius: 10px;
  width: 60px;
  text-align: center;
}

.button-next {
  width: 100px;
  height: 40px;
  border-radius: 20px;
}
.button-back {
  width: 100px;
  height: 40px;
  border-radius: 20px;
}

.text-alert-licence {
  font-size: 13px;
}

.text-max-licence{
  font-size: 13px;
}
.card {
  background-color: #34a9fc;
  color: white;
  border-radius: 15px;
  font-size: 15px;
  margin-top: 15px;
  width: 160px;
  height: 100px;
}

.infor-business {
  font-family: "Nunito";
  font-size: 13px;
}
.purchase-summary-body {
  font-size: 12px;
  margin-top: 23px;
}

.button-time-style {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  width: 70px;
  height: 25px;
  border-radius: 10px;
  color: white;
  background-color: #949494;
  border: solid 1px #949494;
}

.buttom-time {
  display: flex;
}

.purchase-summary-head {
  font-size: 23px;
}
.infor-next-inv {
  margin-left: 3px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #a1a1a1;
}
hr {
  border: 1px solid;
}
.space {
  margin-right: 5px;
}

.buttom-plans-style {
  width: 170px;
  height: 100px;
  border-radius: 20px;
  color: white;
  border: solid 1px #949494;
  background-color: #949494;
}

.box {
  width: 5px;
  height: 450px;
  top: -50%;
}

.line-vertical {
  border-left: 4px solid;
  box-sizing: border-box;
  color: #d6d6d6;
}
.hr-sumary {
  width: 260px;
}
.info-licenses {
  height: 120px;
}
.info-select-div {
  display: flex;
  margin-left: 5px;
  height: 30px;
}
.infor-select {
  font-size: 13px;
}

.infor-select2 {
  font-size: 11px;
  margin-top: 3px;
}
.select-2 {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 5px;
}

.btn-rate {
  font-size: 12px;
  color: #191df7;
  border: none;
  background-color: white;
}
.text-checkbox {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.modal-rate {
  max-width: 700px;
}
.modal-rate-size {
  display: flex;
  justify-content: center;
  width: 800px;
}
@media screen and (max-width: 1200px) {
  .buttom-plans-style {
    width: 110px;
    height: 110px;
    border-radius: 10px;
    color: white;
    border: solid 1px #949494;
    background-color: #949494;
  }

  .text-alert-licence {
    font-size: 13px;
    color: red;
  }

  .resume-buy-box {
    display: flex;
    justify-content: center;
    padding-top: 8px;
    border-top: solid 1px #949494;
  }

  .text-size {
    font-size: 13px;
  }
  .d-xs-none {
    display: none;
  }
}
</style>
